import Header from '../Header/Header.js';
import Footer from '../Footer/Footer.js';
import '../LegalPage/LegalPage.css';
import { EMAIL, PHONE_DISPLAY } from '../../constants/contactInfo.js';
import { Link } from 'react-router-dom';

function PrivacyPolicyPage() {
  return (
    <>
      <Header />
      <main className="content">
        <section className="legalPage">
          <div className="legalPage__hero">
            <h2 className="legalPage__title">
              Политика обработки персональных данных
            </h2>
            <p className="legalPage__lead">
              Настоящая политика определяет порядок обработки персональных
              данных пользователей сайта Самарского областного отделения
              Общероссийской общественной организации «Всероссийское
              добровольное пожарное общество».
            </p>
          </div>

          <div className="legalPage__content">
            <section className="legalPage__section">
              <h3 className="legalPage__section-title">
                1. Оператор и контакты
              </h3>
              <p className="legalPage__text">
                Оператором персональных данных является Самарское областное
                отделение Общероссийской общественной организации
                «Всероссийское добровольное пожарное общество».
              </p>
              <p className="legalPage__text">
                По вопросам, связанным с обработкой персональных данных,
                пользователь может обратиться по телефону `{PHONE_DISPLAY}` и
                по электронной почте `{EMAIL}`.
              </p>
            </section>

            <section className="legalPage__section">
              <h3 className="legalPage__section-title">
                2. Какие данные обрабатываются
              </h3>
              <ul className="legalPage__list">
                <li className="legalPage__list-item">
                  технические данные, автоматически передаваемые устройством
                  пользователя при работе с сайтом, включая IP-адрес, сведения
                  о браузере, дате и времени запроса, адресе запрашиваемой
                  страницы и иные сведения, содержащиеся в серверных журналах;
                </li>
                <li className="legalPage__list-item">
                  данные, сохраняемые в браузере пользователя для технической
                  работы сайта, включая сведения о принятии уведомления о
                  cookie;
                </li>
                <li className="legalPage__list-item">
                  технические и статистические сведения, собираемые сервисом
                  Яндекс Метрика после согласия пользователя, включая адреса
                  посещенных страниц, источники переходов и действия на сайте;
                </li>
                <li className="legalPage__list-item">
                  контактные данные, которые пользователь добровольно
                  предоставляет при обращении по телефону, электронной почте
                  или через форму обратной связи на сайте, включая имя,
                  телефон, адрес электронной почты, организацию, описание
                  запроса и выбранную услугу.
                </li>
              </ul>
            </section>

            <section className="legalPage__section">
              <h3 className="legalPage__section-title">3. Цели обработки</h3>
              <ul className="legalPage__list">
                <li className="legalPage__list-item">
                  обеспечение корректной и безопасной работы сайта;
                </li>
                <li className="legalPage__list-item">
                  публикация и техническая доставка информационных материалов и
                  новостей;
                </li>
                <li className="legalPage__list-item">
                  ведение серверных журналов, диагностика ошибок и защита сайта
                  от сбоев и злоупотреблений;
                </li>
                <li className="legalPage__list-item">
                  анализ посещаемости и улучшение структуры и содержания сайта;
                </li>
                <li className="legalPage__list-item">
                  обработка обращений, направленных пользователем по
                  опубликованным контактным данным и через форму обратной
                  связи на сайте;
                </li>
                <li className="legalPage__list-item">
                  подготовка консультаций, коммерческих предложений, расчетов
                  и уточнение параметров интересующей услуги.
                </li>
              </ul>
            </section>

            <section className="legalPage__section">
              <h3 className="legalPage__section-title">
                4. Правовые основания обработки
              </h3>
              <p className="legalPage__text">
                Обработка персональных данных осуществляется на основании
                Федерального закона от 27.07.2006 № 152-ФЗ «О персональных
                данных», а также при наличии согласия субъекта персональных
                данных в случаях, когда такое согласие требуется.
              </p>
              <p className="legalPage__text">
                Технические данные обрабатываются в объеме, необходимом для
                функционирования сайта и обеспечения информационной
                безопасности. При обращении пользователя по телефону или
                электронной почте правовым основанием также является инициатива
                самого пользователя, направленная на установление контакта с
                оператором. При заполнении формы обратной связи на сайте
                обработка осуществляется на основании согласия субъекта
                персональных данных, выраженного путем установки
                соответствующей отметки в форме.
              </p>
            </section>

            <section className="legalPage__section">
              <h3 className="legalPage__section-title">
                5. Порядок, сроки хранения и прекращение обработки
              </h3>
              <p className="legalPage__text">
                Персональные данные обрабатываются с использованием средств
                автоматизации и без их использования в объеме, необходимом для
                достижения указанных целей. Срок хранения данных определяется
                целью обработки, требованиями законодательства Российской
                Федерации и фактической необходимостью хранения.
              </p>
              <p className="legalPage__text">
                Технические журналы сервера хранятся в течение срока,
                необходимого для администрирования, диагностики и обеспечения
                безопасности сайта. Данные, содержащиеся в локальном хранилище
                браузера, пользователь может удалить самостоятельно через
                настройки браузера.
              </p>
              <p className="legalPage__text">
                Данные из формы обратной связи хранятся в течение срока,
                необходимого для обработки обращения и ведения последующей
                деловой переписки, если более длительное хранение не требуется
                по закону или договорным отношениям.
              </p>
            </section>

            <section className="legalPage__section">
              <h3 className="legalPage__section-title">
                6. Передача данных третьим лицам
              </h3>
              <p className="legalPage__text">
                Оператор не осуществляет продажу или распространение
                персональных данных пользователей. Передача третьим лицам
                возможна только в случаях, предусмотренных законодательством
                Российской Федерации, либо при наличии отдельного законного
                основания.
              </p>
              <p className="legalPage__text">
                После согласия пользователя сайт использует сервис Яндекс
                Метрика для получения статистики посещаемости. При работе формы
                обратной связи данные могут передаваться лицам, обеспечивающим
                хостинг сайта, техническую поддержку и доставку электронных
                сообщений, исключительно в объеме, необходимом для обработки
                обращения.
              </p>
            </section>

            <section className="legalPage__section">
              <h3 className="legalPage__section-title">
                7. Права субъекта персональных данных
              </h3>
              <ul className="legalPage__list">
                <li className="legalPage__list-item">
                  получать сведения об обработке своих персональных данных;
                </li>
                <li className="legalPage__list-item">
                  требовать уточнения, блокирования или уничтожения данных,
                  если они являются неполными, устаревшими, неточными или
                  обрабатываются с нарушением закона;
                </li>
                <li className="legalPage__list-item">
                  отзывать согласие на обработку персональных данных, если
                  обработка основана на согласии;
                </li>
                <li className="legalPage__list-item">
                  обжаловать действия оператора в уполномоченный орган или в
                  судебном порядке.
                </li>
              </ul>
            </section>

            <section className="legalPage__section">
              <h3 className="legalPage__section-title">
                8. Меры по защите данных
              </h3>
              <p className="legalPage__text">
                Оператор принимает разумные организационные и технические меры
                для защиты персональных данных от неправомерного доступа,
                уничтожения, изменения, блокирования, копирования,
                распространения и иных неправомерных действий.
              </p>
            </section>

            <section className="legalPage__section">
              <h3 className="legalPage__section-title">
                9. Дополнительная информация
              </h3>
              <p className="legalPage__text">
                Информация об использовании файлов cookie и технических данных
                размещена на отдельной странице:{' '}
                <Link to="/cookies-policy/" className="legalPage__link">
                  Файлы cookie и технические данные
                </Link>
                .
              </p>
              <p className="legalPage__text">
                Условия согласия пользователя при заполнении формы обратной
                связи размещены на отдельной странице:{' '}
                <Link
                  to="/personal-data-consent/"
                  className="legalPage__link"
                >
                  Согласие на обработку персональных данных
                </Link>
                .
              </p>
            </section>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default PrivacyPolicyPage;
